export const partnerPage = {
    "meta": {
        "title": "DMARCflow Partner Program",
        "description": "Earn passive income by securing your clients' email in 3 minutes with DMARCflow.",
        "ogTitle": "Join the DMARCflow Partner Program",
        "ogDescription": "Help clients protect their email and earn recurring income. No DNS experience needed."
    },
    "hero": {
        "headline": "Earn Passive Income by Securing Your Clients' Email in 3 Minutes",
        "description": "Scan any domain for DMARC compliance, instantly show email vulnerabilities, and offer a €1/month upgrade with DMARCflow. No technical skills or DNS experience required.",
        "cta": "Start Partnering"
    },
    "scanner": {
        "title": "Check Your Client's Domain for Email Vulnerabilities",
        "description": "Scan your client’s domain to check DMARC, SPF, and DKIM email authentication.",
        "hint1": "Instantly see if a domain is unprotected against spoofing, phishing, or deliverability issues - and earn when you help secure it.",
        "hint2": "No login needed — clear results, instantly."
    },
    "howItWorks": {
        "title": "How It Works",
        "description": "Working with us is very easy - just use these tools",
        "steps": [
            {
                "title": "Scan",
                "desc": "Use our instant tool to analyze any domain for missing DMARC, SPF, or DKIM records."
            },
            {
                "title": "Report",
                "desc": "A clear, easy-to-understand DMARC report is generated - no jargon, no confusion."
            },
            {
                "title": "Share",
                "desc": "Share the report and recommend the €x/month fix with your unique link."
            },
            {
                "title": "Earn",
                "desc": "Your client gets secure email delivery - you get monthly recurring income."
            }
        ]
    },
    "benefits": {
        "title": "Why Partners Love DMARCflow",
        "description": "Earn Recurring Income While Helping Clients Stay Secure",
        "points": [
            "No DNS or tech work required — perfect for marketers, freelancers, VAs, or agencies.",
            "Clients care about deliverability – without DMARC, their emails go to spam.",
            "You become more valuable — add real security to your services.",
            "Low-friction €1/month plan – simple pricing clients say yes to."
        ],
        "commission": {
            "title": "Partner Commission & Payouts",
            "description": "Earn 10% to 30% recurring monthly commissions — or choose a one-time payout. Your income grows as your client list grows.",
            "tiersTitle": "Commission Tiers",
            "tiers": [
                "✅ 10% for 1–10 clients",
                "✅ 20% for 11–50 clients",
                "✅ 30% for 51+ clients"
            ],
            "footer": "💸 Payouts via Stripe or PayPal. Realtime dashboard included."
        }
    },
    "cta": {
        "title": "Join the DMARCflow Partner Program Today",
        "description": "Ready to add a powerful new income stream and improve client email security - with zero tech hassle?",
        "button": "Join Now – It’s Free"
    },
    "faq": {
        "title": "Everything You Need to Know",
        description: "You Have Questions? We have Answers!",
        "questions": [
            {
                "q": "How do I track my earnings and clients?",
                "a": "Use your Partner Dashboard to view commissions, client referrals, and monthly payout history."
            },
            {
                "q": "Is it free to join the Partner Program?",
                "a": "Yes — it’s 100% free. You only make money, never spend it."
            },
            {
                "q": "What support do I get as a partner?",
                "a": "We provide templates, onboarding guides, live chat, and email support."
            },
            {
                "q": "When do I get paid?",
                "a": "Payouts are processed at the beginning of each month for the previous month’s earnings."
            },
            {
                "q": "Can I white-label DMARCflow for my clients?",
                "a": "Absolutely. Use our templates and assets to present DMARCflow as part of your service."
            }
        ]
    }
}